export default __webpack_public_path__ + "static/media/mag-white.9058925b.svg";